import React, { useCallback, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Modal } from 'react-bootstrap'
import { FaFloppyDisk } from 'react-icons/fa6'

import { Form } from '../Form'
import { DataType } from '../../types'

export type ModalFormResult = 'Save' | 'Cancel'

export type ModalFormProps<T extends DataType> = {
    formName: string
    heading: string
    size?: 'sm' | 'lg' | 'xl' 
    show: boolean
    initialData: T
    onClose: ( closeBtn: ModalFormResult, data?: T ) => void
    children: React.ReactNode
}

export const ModalForm = <T extends DataType>( { formName, heading, size, show, initialData, onClose, children }: ModalFormProps<T> ) => {

    const handleCancel = () => {
        onClose( 'Cancel' )
    }

    return <Modal
        show={ show }
        onHide={ handleCancel }
        backdrop='static'
        keyboard={ false }
        size={ size }
        centered
    >
        <Form
            className='w-100'
            formName={ formName }
            initialData={ initialData }
            onFinishCallback={ ( form ) => onClose( 'Save', form.data as T ) }
        >
            <Modal.Header closeButton>
                <Modal.Title>{ heading }</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { children }
            </Modal.Body>
            <Modal.Footer>
                <Button type="submit" variant="primary" >
                    <FaFloppyDisk /><FormattedMessage description='Forms.ModalForm.Save' defaultMessage='Save' />
                </Button>
                <Button variant="secondary" onClick={ handleCancel } >
                    <FormattedMessage description='Forms.ModalForm.Cancel' defaultMessage='Cancel' />
                </Button>
            </Modal.Footer>
        </Form>
    </Modal>
}
